import { PageType } from '../../../page-edit-screen/page-type';

export enum PageStatus {
  DRAFT_ONLY = 'DRAFT_ONLY',
  DRAFT_AND_LIVE = 'DRAFT_AND_LIVE',
  LIVE_ONLY = 'LIVE_ONLY',
}

export enum DisplayedType {
  LandingPageWeb = 'Landing page - Web',
  LandingPageMobile = 'Landing page - Mobile',
  LandingPageTablet = 'Landing page - Tablet',
  LandingPageCoTv = 'Landing page - COTV',
  LandingPageAppleAndroidTv = 'Landing page - Apple TV & Android TV',
  DetailedPageWeb = 'Detailed page - Web',
  GenericRedeem = 'Generic redeem',
  PartnerRedeem = 'Partner redeem',
}

export type TabType = 'content' | 'marketing' | 'redeem' | 'genre' | 'collection';

export interface PageListViewModel {
  targetPageId: string;
  pageName: string;
  lastPublished: string;
  status: PageStatus;
  pageType: PageType;
  displayedType: DisplayedType;
  countries: string[];
  userSegments: string[];
  livePageUrl: string;
  attachedGenre: string;
}

export interface PageScreenViewModel {
  contentPages: PageListViewModel[];
  marketingPages: PageListViewModel[];
  redeemPages: PageListViewModel[];
  genrePages: PageListViewModel[];
  collectionPages: PageListViewModel[];
  isLoading: boolean;
  subRoute: TabType;
}
